(ns css.vars)

;; Colors
(def red "#FF0000")
(def green "#069900")
(def orange "#FFA500")
(def gray "#666666")
(def gray-light "#F6F6F6")
(def gold "#d7a900")
(def border-light "#DADBDA")
(def text "#144633")
(def text-light "#666666")
(def title "#4B4B4B")
(def black "#3D3D3D")
(def jellybean "#268892")

;; Layout
(def container-grid "[left-gutter-start] minmax(1rem, 1fr) [left-gutter-end content-start] minmax(min-content, 82rem) [content-end right-gutter-start] minmax(1rem, 1fr) [right-gutter-end]")